export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./branch-games-list.vue?vue&type=template&id=b003a504"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/games/branch-games-list.vue?vue&type=template&id=b003a504
// module id = /+ke
// module chunks = 0